import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Organization',
  icon: 'mdi-office-building-outline',
  path: '/mt/admin/organization',
  ...addPermissionsToRoute(['permissions_access']),
  children: [
    {
      path: '/mt/admin/organization/orgTimeslices',
      name: 'TimeSlices',
      component: () => import('./timeslices/TimeSlices.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/mt/admin/organization/orgPatches',
      name: 'Patches',
      component: () => import('./patches/Patches.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/mt/admin/organization/orgWatchLists',
      name: 'WatchLists',
      component: () => import('./watchlists/WatchLists.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
  ],
};

export default routes;
